var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileMob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.87095 0 0.5 5.37095 0.5 12C0.5 18.6291 5.87095 24 12.5 24C19.1291 24 24.5 18.6291 24.5 12C24.5 5.37095 19.1291 0 12.5 0ZM12.5 3.6C14.4857 3.6 16.1 5.21432 16.1 7.2C16.1 9.18568 14.4857 10.8 12.5 10.8C10.5143 10.8 8.9 9.19074 8.9 7.2C8.9 5.20926 10.5143 3.6 12.5 3.6ZM12.5 20.64C9.49368 20.64 6.85368 19.104 5.3 16.7747C5.33032 14.3924 10.1051 13.0787 12.5 13.0787C14.8949 13.0787 19.6646 14.3924 19.7 16.7747C18.1463 19.104 15.5063 20.64 12.5 20.64Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMob);
export default __webpack_public_path__ + "static/media/profile-mob.ae86030e063fb37ddcb9aa717d91030a.svg";
export { ForwardRef as ReactComponent };